module.exports = __webpack_public_path__ + "img/2.9ed1241e.png";